import React from 'react'
import Overview from '../components/Overview'
import Team from '../components/Team'

const AboutPage = () => {
  return (
    <div>
      <Overview/>
      <Team/>
    </div>
  )
}

export default AboutPage
